<template>
  <b-card>
    <b-row
      align-h="end"
      style="gap: 1rem; margin-bottom: 10px;"
    >
      <b-col>
        <b-badge
          variant="light-warning"
          style="margin-bottom: 0px; padding: 10px; white-space: normal;"
        >
          Algumas filiais não são exibidas devido ao fato de terem as mesmas mensagens na Caixa Postal que a Matriz cadastrada.
        </b-badge>
      </b-col>
    </b-row>
    <caixapostal-list
      id="caixapostalList"
      ref="caixapostalList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
      :tem-filtro-extra="true"
      filtro-extra-custom="auto"
      :show-botao-custom="isFiltroNovoNoMonitor"
      ultima-rota="mensagem-view"
      filtro-de-holder="Data inicial de envio"
      filtro-para-holder="Data final de envio"
      filtro-de-para
      :tem-limpar-filtros="true"
      :row-style-class="rowStyleClassFn"
    >
      <template slot="filtro-extra">
        <download-em-excel
          :filtro="filtroAtual"
          :api="apiCaixaPostal"
          :get-info-extra="montarDto"
          alterar-style="padding: 0.8rem;"
        />
      </template>

      <template slot="show-botao-custom">
        <filtro-rapido
          ref="filtroRapido"
          :filtros="filtroRapidoSecundario"
          :filtro-atual="filtroAtualSecundario"
          filtro-nome="Periodo"
          @selecionado="$refs.caixapostalList.aplicarFiltroRapido({...$event, queryName: 'dias', colunas: ['NovasNoMonitorSecundario'] }, false)"
        />
      </template>

      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <span
          v-if="['consultadoEm', 'cadastroFederal', 'razaoSocial'].includes(props.column.field)"
          style="display: flex; justify-content: space-between; align-items: center; position: relative;"
          @click.stop="props.column.field === 'razaoSocial' && visualizarTodasMsg(props.row)"
        >
          <span
            :style="{
              fontWeight: props.row.mensagemLida === false ? 'bold' : 'normal',
              wordBreak: 'break-word',
              flex: 1
            }"
          >
            {{ props.formattedRow[props.column.field] }}
          </span>

          <b-badge
            v-if="props.column.field === 'razaoSocial' && props.row.mensagemLida === false && props.row.mensagemNova !== '-'"
            :style="{
              backgroundColor:
                props.row.mensagemNova === 'amarelo'
                  ? 'rgba(217, 175, 11, 0.3)' // amarelo translúcido
                  : props.row.mensagemNova === 'azul'
                    ? 'rgba(16, 69, 171, 0.3)' // azul translúcido
                    : props.row.mensagemNova === 'vermelho'
                      ? 'rgba(220, 53, 69, 0.3)' // vermelho translúcido
                      : 'rgba(108, 117, 125, 0.3)', // cinza translúcido
              color:
                props.row.mensagemNova === 'amarelo'
                  ? '#b48a00'
                  : props.row.mensagemNova === 'azul'
                    ? '#0d2e91'
                    : props.row.mensagemNova === 'vermelho'
                      ? '#b8222d'
                      : '#4a4a4a',
              fontSize: '0.8rem',
              padding: '0.2rem 0.4rem',
              lineHeight: '1',
              borderRadius: '0.25rem',
              marginLeft: '6px',
              whiteSpace: 'nowrap'
            }"
            class="badge-size-p"
          >
            Nova no Monitor
          </b-badge>
        </span>
        <div
          v-if="props.column.field === 'qtdNaoLidas'"
          class="d-block"
          :class="{ 'font-weight-bold': props.row.mensagemLida === false }"
        >
          <b-badge
            v-if="props.row['nenhumaMsg']"
            variant="light-success"
          >
            Sem mensagens
          </b-badge>
          <b-badge
            v-else-if="props.row['qtdNaoLidas'] > 0"
            variant="light-warning"
          >
            {{ props.row['qtdNaoLidas'] }} {{ props.row['qtdNaoLidas'] > 1 ? 'não lidos' : ' não lido' }}
          </b-badge>
          <b-badge
            v-else-if="!props.row['nenhumaMsg']"
            variant="light-success"
          >
            Todas lidas
          </b-badge>
        </div>
      </template>
      <template
        slot="acoes"
        slot-scope="{ props} "
      >
        <span
          v-b-tooltip.hover="getTooltipConfig(props.row)"
          tabindex="0"
          style="display: inline-block;"
        >
          <b-btn
            variant="none"
            class="btn btn-none mr-50"
            :class="{'btn-acao-erro': isErroCaixaPostal(props.row), 'rounded-pill': !isErroCaixaPostal(props.row)}"
            style="padding: 0.4rem;"
            :style="isBotaoInativo(props.row) ? { 'pointer-events': 'none' } : {}"
            :disabled="isBotaoInativo(props.row)"
            @click="visualizarTodasMsg(props.row)"
          >
            <font-awesome-icon
              icon="fa-solid fa-envelopes-bulk"
              :class="getIconClass(props.row)"
              size="lg"
            />
          </b-btn>
        </span>
      </template>
    </caixapostal-list>
  </b-card>
</template>

<style lang="scss">
.modal-lg {
  max-width: 1000px !important;
}

.data-width {
  width: 120px !important;
}
.caixapostal-td-acao {
  // min-width: 0.5rem;
  width: 12px;
}
.sem-permissao-caixa-postal td {
  background-color: #F0F8FF !important;
}
.caixa-postal-nao-habilitada td {
  background-color: #F0F8FF !important;
}
.text-custom-red {
  color: rgb(184, 34, 45) !important;
}
.btn-acao-erro {
  background-color: rgb(220 53 69 / 9%) !important;
  color: rgb(184, 34, 45) !important;
  font-size: 0.8rem;
  padding: 0.2rem 0.4rem !important;
  line-height: 1;
  border-radius: 0.25rem;
  margin-left: 6px;
  white-space: nowrap;
}
</style>

<script>

import colunas from './shared/components/colunas'
import api from './shared/services/api'

export default {
  name: 'CaixaPostalVisualizacao',
  components: {
    CaixapostalList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    FiltroRapido: () => import('@pilar/components/visualizacao-base/components/filtro-rapido/FiltroRapido.vue'),
    DownloadEmExcel: () => import('@app/download-excel/DownloadEmExcel.vue'),
  },
  data() {
    return {
      apiCaixaPostal: api,
      filtroAtual: {},
      filtroAtualSecundario: null,
      isFiltroNovoNoMonitor: false,
      botoesOption: null,
      linha: null,
      visualizacao: {
        placeholderBusca: 'Buscar por: CNPJ/CPF, Razão social ou Assunto',
        acaoClass: 'caixapostal-td-acao',
        disabledCheckbox: false,
      },
      filtros: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial', 'Assunto', 'ConsultadoEm'], valor: null }],
      filtroRapidoSecundario: [
        {
          id: 'Ate7',
          label: 'Até 7 dias',
          valor: true,
        },
        {
          id: '7a15',
          label: '8 à 15 dias',
          valor: true,
        },
        {
          id: 'Acima15',
          label: 'Acima de 15',
          valor: true,
        },
      ],
      filtrosRapidos: [
        {
          id: 'Pronampe',
          colunas: ['TipoMensagem'],
          label: 'Pronampe',
          valor: '2',
        },
        {
          id: 'CaixaPostalNaoHabilitada',
          colunas: ['Status'],
          label: 'Caixa postal não habilitada',
          valor: '18',
        },
        {
          id: 'MalhaFiscal',
          colunas: ['TipoMensagem'],
          label: 'Malha fiscal',
          valor: '1',
        },
        {
          id: 'TermoIntimacao',
          colunas: ['TipoMensagem'],
          label: 'Termo de intimação',
          valor: '3',
        },
        {
          id: 'TermoIntimacaoNaoLida',
          colunas: ['IntimacaoNaoLida'],
          label: 'Termo(s) de Intimação não lidas',
          valor: true,
        },
        {
          id: 'TermoIntimacaoLida',
          colunas: ['IntimacaoLida'],
          label: 'Termo(s) de Intimação lidas',
          valor: true,
        },
        {
          id: 'TermoExclusao',
          colunas: ['TipoMensagem'],
          label: 'Termo de exclusão',
          valor: '4',
        },
        {
          id: 'TermoIndeferimento',
          colunas: ['TipoMensagem'],
          label: 'Termo de indeferimento',
          valor: '5',
        },
        {
          id: 'Lidas',
          colunas: ['Lidas'],
          label: 'Lidas',
          valor: true,
        },
        {
          id: 'NaoLidas',
          colunas: ['NaoLidas'],
          label: 'Não lidas',
          valor: false,
        },
        {
          id: 'Relevante',
          colunas: ['Relevante'],
          label: 'Relevantes',
          valor: true,
        },
        {
          id: 'RelevanteNaoLido',
          colunas: ['RelevanteNaoLido'],
          label: 'Relevantes Não Lidas',
          valor: true,
        },
        {
          id: 'SemMensagem',
          colunas: ['Assunto'],
          label: 'Sem mensagens',
          valor: 'Contribuinte não possui mensagens em sua caixa postal.',
        },
        {
          id: 'EProcesso',
          colunas: ['EProcesso'],
          label: 'e-Processos',
          valor: true,
        },
        {
          id: 'EProcessoNaoLida',
          colunas: ['EProcessoNaoLida'],
          label: 'e-Processos não lidas',
          valor: true,
        },
        {
          id: 'PossuiObservacao',
          colunas: ['PossuiObservacao'],
          label: 'Possui observação',
          valor: true,
        },
        {
          id: 'NovasNoMonitor',
          colunas: ['NovasNoMonitor'],
          label: 'Novas no Monitor',
          valor: false,
        },
      ],
    }
  },
  created() {
    this.visualizacao.colunas = colunas
    this.visualizacao.colunas[0].evento = this.visualizarTodasMsg
    this.visualizacao.evento = this.carregar
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  methods: {
    /* eslint-disable no-param-reassign */
    montarDto() {
      if (this.$refs.caixapostalList) {
        const selecionados = this.$refs.caixapostalList.linhaSelecionada
        this.filtroAtual.empresasSelecionadas = selecionados || []
      }
      return this.filtroAtual
    },
    carregar(pagina, tamanhoPagina, filtros) {
      this.filtroAtual = filtros
      const filtrosBy = filtros.filtroBy || null
      this.ativarFiltroRapidoSecundario(filtrosBy)

      return api.getPaginado(pagina, tamanhoPagina, filtros)
    },
    visualizarTodasMsg(row) {
      if (!row.nenhumaMsg) {
        this.$router.push({
          name: 'mensagem-view',
          query: {
            busca: this.$route.query.busca || '',
            filtroRapido: this.$route.query.filtroRapido ? this.$route.query.filtroRapido : '',
            dias: this.$route.query.dias ?? '',
            dataInicio: this.$route.query.dataInicio ? this.$route.query.dataInicio : '',
            dataFim: this.$route.query.dataFim ? this.$route.query.dataFim : '',
          },
          params: { id: row.id, nome: row.razaoSocial, cnpj: row.cadastroFederal },
        })
      }
    },
    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.caixapostalList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.caixapostalList.aplicarFiltro(params.busca, filtroRapido)

          setTimeout(() => {
            this.filtroAtualSecundario = params.dias
              ? this.filtroRapidoSecundario.find(f => f.id === params.dias)
              : null
          }, 300)
        }
      })
    },
    ativarFiltroRapidoSecundario(filtros) {
      this.isFiltroNovoNoMonitor = filtros?.some(a => a.id === 'NovasNoMonitor') || false
    },
    isErroCaixaPostal(row) {
      const status = Number(row.status)
      return status === 3 || status === 18 || row.mensagemErro === 'CaixaPostalNaoHabilitada'
    },
    isBotaoInativo(row) {
      if (this.isErroCaixaPostal(row)) {
        return row.possuiMensagens === false
      }
      return row.nenhumaMsg
    },
    rowStyleClassFn(row) {
      if (this.isErroCaixaPostal(row)) return 'caixa-postal-nao-habilitada'
      return ''
    },
    /** Retorna a configuração do tooltip para o botão de ação */
    getTooltipConfig(row) {
      const baseConfig = { placement: 'top', boundary: 'window', fallbackPlacement: [] }
      if (this.isErroCaixaPostal(row)) {
        if (row.possuiMensagens === false) {
          return { ...baseConfig, title: 'Procuração sem permissão para caixa postal', variant: 'warning' }
        }
        if (row.possuiMensagens === true) {
          return { ...baseConfig, title: 'Procuração sem permissão para caixa postal. Visualizar mensagens antigas.', variant: 'warning' }
        }
        return { ...baseConfig, title: 'Nenhum histórico disponível', variant: 'danger' }
      }
      return { ...baseConfig, title: 'Visualizar todas as mensagens' }
    },
    getIconClass(row) {
      if (this.isErroCaixaPostal(row)) return 'text-custom-red'
      return 'text-primary'
    },
  },
}
</script>
